import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {CaseFormsService} from '../../case-forms/case-forms.service';
import {MessagingService} from '../../../services/messaging.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormConfigurationModel} from '../../../models/forms/form-configuration.model';
import {PatientCaseWorkItemFormDataModel} from '../../../models/forms/data/patient-case-work-item-form-data.model';
import {TdoTableSelectionEvent} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {InsuranceService} from '../insurance.service';
import {DialogService} from '../../../services/dialog.service';
import {OrganizationDataModel} from '../../../models/organization/organization-data.model';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {OrganizationContactDataModel} from '../../../models/organization/organization-contact-data.model';

import {ConfirmActionButton, GeneralConfirmComponent} from '../../tdo-shared/general-confirm/general-confirm.component';
import {InsuranceNoFeeScheduleDialogComponent} from '../insurance-no-fee-schedule-dialog/insurance-no-fee-schedule-dialog.component';
import { forEach } from 'cypress/types/lodash';
import {InsuranceCompanyManagerComponent} from '../insurance-company-manager/insurance-company-manager.component';

@Component({
  selector: 'app-insurance-company-picker',
  templateUrl: './insurance-company-picker.component.html',
  styleUrls: ['./insurance-company-picker.component.scss']
})
export class InsuranceCompanyPickerComponent implements OnInit {

  searchPredicate: (data: any, filter: string) => boolean;
  isLoading: boolean;
  dataOrganizations: OrganizationDataModel[] = [];
  dataOrganization: OrganizationDataModel;
  enumOrganizationTypeId: string;
  emptyGuid: string = '00000000-0000-0000-0000-000000000000';
  useUCR: boolean = false;
  settingsWindow: Window;

  constructor(
    public dialogRef: MatDialogRef<InsuranceCompanyPickerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private insuranceService: InsuranceService,
    private messagingService: MessagingService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private dialogService: DialogService,
  )
  {
    this.searchPredicate = (searchData: any, filter: string) => {
      if ((!searchData.model.OrganizationName ? '' : searchData.model.OrganizationName).toLowerCase().includes(filter)) {
        return true;
      }
      else {
        return false;
      }
    };
  }

  ngOnInit(): void {

    // enumOrganizationTypeId
    if (this.data && this.data.enumOrganizationTypeId) {
      this.enumOrganizationTypeId = this.data.enumOrganizationTypeId;
    }

    this.loadInsuranceCompanies();
  }

  async loadInsuranceCompanies() {

    this.isLoading = true;

    // get data
    const promises: any[] = [
      this.getDataOrganizationsByType(),
    ];

    try {
      const results: any[] = await Promise.all(promises);
      this.dataOrganizations = results[0];

      console.log(this.dataOrganizations );



      this.isLoading = false;
    } catch (err) {
      this.isLoading = false;
      this.showMessage('Something went wrong', 'Error');
    }
  }

  getDataOrganizations() {
    const promise = new Promise((resolve, reject) => {
      this.insuranceService.getAllOrganizations()
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  getDataOrganizationsByType() {
    const promise = new Promise((resolve, reject) => {
      this.insuranceService.getAllOrganizationsByType(this.enumOrganizationTypeId)
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });
    });
    return promise;
  }


  showMessage(type, message) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top',
      panelClass: ['snackbar-linebreaks']
    });
  }

  close(payload) {
    this.dialogRef.close(payload);
  }

  onRowSelected($event: TdoTableSelectionEvent) {
    if ($event.isSelected) {
      this.dataOrganization = $event.model;
    }
    else {
      this.dataOrganization = null;
    }
  }

  async OrganizationChosen() {
    // check to see if organization has a fee schedule
    // if it does, proceed
    // if it doesn't, then show alert to user, and don't allow them to proceed

    // get data
    const promises: any[] = [
      this.insuranceService.getFeeScheduleIDByOrganizationId(this.dataOrganization.OrganizationID).toPromise(),
    ];

    try {
      const results: any[] = await Promise.all(promises);
      const feeScheduleID: string = results[0].FeeScheduleID;
      const FeeScheduleName: string = results[0].FeeScheduleName      ;

console.log('fee sched: ', results[0]);

      if ( feeScheduleID == undefined || feeScheduleID == this.emptyGuid  ) {
        // fee schedule not yet created
        this.openWarningDialogChooseInsurance();
      }
      else {

        // fee schedule exists, proceed

        this.useUCR = false;

        this.dialogRef.close({org: this.dataOrganization, useUCR: this.useUCR, feeScheduleId: results[0].FeeScheduleID ,  feeScheduleName: results[0].FeeScheduleName });


      }
    } catch (err) {
      this.showMessage('Something went wrong', 'Error');
    }
  }

  onOrganizationRowSelected(event: TdoTableSelectionEvent) {
    this.dataOrganization = event.row.model;
  }

  returnOrganizationContactsString(dataOrganizationContacts: OrganizationContactDataModel[]) {
    let contactString = '';
    dataOrganizationContacts.forEach(a => {
      if (a.dataContact) {
        contactString += a.dataContact.FirstName ? a.dataContact.FirstName + ' ' : ' ';
        contactString += a.dataContact.LastName ? a.dataContact.LastName + ' ' : ' ';

        if (a.dataContact.dataContactComms) {
          const phone = a.dataContact.dataContactComms.find(b => b.enumCommMethodID === '00000009-1000-0000-0000-000000000001');
          if (phone) {
            contactString += phone.Address ? phone.Address : '';
          }
        }
      }
    });
    return contactString;
  }

  returnOrganizationFeeScedulesString(  listOfFeeSched : any )  {
    let feeString = '';


    listOfFeeSched.forEach(a => {
        if(a.xauditDeleted === false)
        if(a.FeeScheduleName)
        {

          feeString += a.FeeScheduleName+ ', ';

        }

    }

    );

    if( feeString === '')
      feeString='No Fee Scedule found!';

    return feeString;
  }

  openWarningDialogChooseInsurance() {
    const dialogRef = this.dialog.open(InsuranceNoFeeScheduleDialogComponent, {
      panelClass: 'dialog',
      data: {
        OrganizationName: this.dataOrganization.OrganizationName
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.useUCR = true;
        this.dialogRef.close({org: this.dataOrganization, useUCR: this.useUCR});
      }
      else {
        this.useUCR = false;
      }
    }, err => {
    });
  }

  AddOrganization() {
    this.openDialogManageInsuranceCompanies();
  }

  openSettingsWindow(isReload = false) {
    if (!this.settingsWindow || (this.settingsWindow && this.settingsWindow.closed) || isReload) {
      this.settingsWindow = window.open('/configuration/insurance-companies', 'draw', 'toolbar=1,location=1,menubar=1');
    } else {
      this.settingsWindow.focus();
    }
  }

  openDialogManageInsuranceCompanies() {
    // open a window to add insurance companies
    const dialogRef = this.dialog.open(InsuranceCompanyManagerComponent, {
      width: '950px',
      height: '850px',
      panelClass: 'dialog',
      data: {
        showOnlyInsurance: true,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      // reload list
      this.loadInsuranceCompanies();
    }, err => {
    });
  }
}
